<template>
  <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
    <v-container :class="$vuetify.breakpoint.xsOnly ? '' : 'elevation-2'">
      <v-text-field
        :label="labels.nombre"
        v-model="form.nombre"
        :error-messages="errors.nombre"
        :rules="[rules.required('nombre')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        :label="labels.primer_apellido"
        v-model="form.primer_apellido"
        :error-messages="errors.primer_apellido"
        :rules="[rules.required('primer_apellido')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        :label="labels.segundo_apellido"
        v-model="form.segundo_apellido"
        :error-messages="errors.segundo_apellido"
        :rules="[rules.required('segundo_apellido')]"
        :disabled="loading"
      ></v-text-field>

      <v-autocomplete
        @keyup.enter="$event.target.blur()"
        :label="labels.cargo"
        v-model="form.cargo.id"
        :error-messages="errors.cargo"
        :rules="[rules.required('cargo')]"
        :disabled="loading"
        :items="cargos"
        item-text="nombre"
        item-value="id"
        dense
        hide-no-data
      ></v-autocomplete>

      <v-text-field
        :label="labels.curp"
        v-model="form.curp"
        :error-messages="errors.curp"
        :rules="[rules.required('curp')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        :label="labels.rfc"
        v-model="form.rfc"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        :label="labels.abreviatura_titulo"
        v-model="form.abreviatura_titulo"
        :disabled="loading"
      ></v-text-field>

      <v-select
        :label="labels.documento_a_firmar"
        v-model="form.documento_a_firmar"
        :items="documentos"
        :error-messages="errors.documento_a_firmar"
        :rules="[rules.required('documento_a_firmar')]"
        :disabled="loading"
        dense
      ></v-select>

      <v-select
        :label="labels.tipo_de_rvoe_a_firmar"
        v-model="form.tipo_de_rvoe_a_firmar"
        :items="tipo_de_rvoe"
        :error-messages="errors.tipo_de_rvoe_a_firmar"
        :rules="[rules.required('tipo_de_rvoe_a_firmar')]"
        :disabled="loading"
        dense
      ></v-select>

      <v-autocomplete
        @keyup.enter="$event.target.blur()"
        :label="labels.campuses_a_firmar"
        v-model="form.campuses"
        :disabled="loading"
        :items="campuses"
        item-text="nombre"
        item-value="id"
        attach
        chips
        multiple
        deletable-chips
        dense
        hide-no-data
      ></v-autocomplete>
    </v-container>

    <v-layout justify-end mt-2>
      <v-btn
        flat
        :disabled="loading"
        @click="$router.go(-1)"
        color="grey darken-2"
      >
        Cancelar
      </v-btn>

      <v-btn
        type="submit"
        :loading="loading"
        :disabled="loading"
        color="primary"
      >
        Guardar
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      form: {
        cargo: {},
      },
      campuses: [],
      cargos: [],
      documentos: ['Certificados', 'Títulos'],
      tipo_de_rvoe: ['Federal', 'Estatal'],
    }),

    computed: mapGetters({
    }),

    mounted() {
      this.getCatalogoCargo()
      this.getCampuses()
    },

    methods: {
      getCatalogoCargo() {
        axios
          .get(api.path('catalogos.cargo'))
          .then(res => {
            this.cargos = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      getCampuses() {
        axios
          .get(api.path('campus'))
          .then(res => {
            this.campuses = res.data.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      submit() {
        if (this.$refs.form.validate()) {
          this.loading = true

          axios.post(api.path('responsables'), this.form)
            .then(res => {
              this.$toast.success('Responsable agregado correctamente.')
              this.$emit('success', res.data)
            })
            .catch(err => {
              this.handleErrors(err.response.data.errors)
            })
            .then(() => {
              this.loading = false
            })
        }
      }
    }
  }
</script>
